import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from './constants';

// Import translation files
// Common translations (shared across screens)
import enUSCommon from './locales/en-US/common.json';
import jaJPCommon from './locales/ja-JP/common.json';
// Screen-specific translations
import enUSLogin from './locales/en-US/login.json';
import jaJPLogin from './locales/ja-JP/login.json';
import enUSHome from './locales/en-US/home.json';
import jaJPHome from './locales/ja-JP/home.json';
import enUSMeasurement from './locales/en-US/measurement.json';
import jaJPMeasurement from './locales/ja-JP/measurement.json';
import enUSOwnedSocial from './locales/en-US/ownedSocial.json';
import jaJPOwnedSocial from './locales/ja-JP/ownedSocial.json';
import enUSBenchmarking from './locales/en-US/benchmarking.json';
import jaJPBenchmarking from './locales/ja-JP/benchmarking.json';
import enUSTools from './locales/en-US/tools.json';
import jaJPTools from './locales/ja-JP/tools.json';
import enUSSettings from './locales/en-US/settings.json';
import jaJPSettings from './locales/ja-JP/settings.json';
import enUSPdf from './locales/en-US/pdf.json';
import jaJPPdf from './locales/ja-JP/pdf.json';
import {
    browserLanguageDetector,
    guestUserLanguageDetector,
    authenticatedUserLanguageDetector,
} from './detectors';

const resources = {
    'en-US': {
        common: enUSCommon,
        login: enUSLogin,
        home: enUSHome,
        measurement: enUSMeasurement,
        ownedSocial: enUSOwnedSocial,
        benchmarking: enUSBenchmarking,
        tools: enUSTools,
        settings: enUSSettings,
        pdf: enUSPdf,
    },
    'ja-JP': {
        common: jaJPCommon,
        login: jaJPLogin,
        home: jaJPHome,
        measurement: jaJPMeasurement,
        ownedSocial: jaJPOwnedSocial,
        benchmarking: jaJPBenchmarking,
        tools: jaJPTools,
        settings: jaJPSettings,
        pdf: jaJPPdf,
    },
};

const languageDetector = new LanguageDetector();

languageDetector.addDetector(browserLanguageDetector);
languageDetector.addDetector(guestUserLanguageDetector);
languageDetector.addDetector(authenticatedUserLanguageDetector);

i18n.use(languageDetector)
    .use(initReactI18next)
    // Initialize i18next
    .init({
        resources,
        fallbackLng: DEFAULT_LANGUAGE,
        supportedLngs: SUPPORTED_LANGUAGES,

        // Default namespace (for shared translations)
        defaultNS: 'common',
        // Available namespaces (add new screens here)
        ns: [
            'common',
            'login',
            'home',
            'measurement',
            'ownedSocial',
            'benchmarking',
            'tools',
            'settings',
            'pdf',
        ],

        // Language detection options
        detection: {
            lookupQuerystring: 'lang',
            // Order of language detection methods:
            order: ['querystring', 'guestUser', 'authenticatedUser'],
        },

        interpolation: {
            // React already escapes values
            escapeValue: false,
        },

        // React specific options
        react: {
            useSuspense: false,
        },
    });

export default i18n;
